import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import { firstValueFrom } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { QuickshghtService } from 'src/app/shared/services/quickshght.service';
import * as moment from 'moment';
import { SelectFiltersPopUpComponent } from '../report-configuration/select-filters-pop-up/select-filters-pop-up.component';
import { MatDialog } from '@angular/material/dialog';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-alert-mapping-quicksight',
    templateUrl: './alert-mapping-quicksight.component.html',
    styleUrls: ['./alert-mapping-quicksight.component.scss'],
    standalone: false
})
export class AlertMappingQuicksightComponent implements AfterViewInit {

  @ViewChild('embeddingContainer', { static: true })
  embeddingContainer!: ElementRef<HTMLDivElement>;

   @Input() navigatedFrom: any;
   @Output() back = new EventEmitter<void>();
   @Output() next = new EventEmitter<String>();

  private dashboardExperience: any;
 productOptions = [
    { label: 'All Products', value: null },
    { label: 'Amlodipine', value: 'AMLODIPINE' },
    { label: 'Metformin', value: 'METFORMIN' },
    { label: 'Crocin', value: 'Crocin' },
    { label: 'Aspirin', value: 'Aspirin' },
    { label: 'Ibuprofen', value: 'Ibuprofen' }
  ];

  alertOptions = [
    { label: 'All Alerts', value: null },
    { label: 'Company DB', value: 'Company DB' },
    { label: 'FDA Alert', value: 'FDA Alert' },
    { label: 'SDR Geriatr', value: 'SDR Geriatr' },
    { label: ' SDR EB05 All', value:  'SDR EB05 All' },
  ];

  dataSourceOptions = [
    { label: 'All Datasource', value: null },
    { label: 'FAERS', value: 'FAERS' },
    { label: 'EVDAS', value: 'EVDAS' },
    { label: 'Safety Database', value: 'Safety Database' }
  ];
  rangeStartDate: any | null = null;
  rangeEndDate: any | null = null;
  startDate: any | null = null;
  endDate: any | null = null; 
  sheetId
  private embeddingContext: any;
  private sheetsPrinted = false;

  // ====== QUICKsight identifiers (CHANGE THESE) ======
  // You MUST use dataset identifier used in the dashboard definition
  private readonly DATASET_ID = 'Report';

  // ColumnName must match EXACT field names in QuickSight dataset
  private readonly COL_PRODUCT = 'Product';
  private readonly COL_ALERT = 'Alert';
  private readonly COL_DATASOURCE = 'DataSource';
  private readonly COL_DATE = 'CreatedDate'; // or whatever your date column is

  private readonly FILTER_GROUP_ID = 'fgalertmapping';
  private filterGroupAdded = false;

   // ====== FILTER UI VALUES ======
  selectedProduct: string | null = null;
  selectedAlert: string | null = null;
  selectedDataSource: string | null = null;
  isSidenavOpen=true;
  selectedProductDetails:any=null;

  datasetData;
  selectedFiltersListData=[];

  constructor(
    private quickSightService: QuickshghtService,
    private spinner: NgxUiLoaderService,
    private dialog: MatDialog,
    private linkservice: ReportlinksserviceService,
    private snackbar: MatSnackBar
  ) {}

  async ngAfterViewInit() {
    if(this.navigatedFrom != 'ReviewActivity'){
      this.isSidenavOpen=false
    }
     this.spinner.start();
     this.getDatasetDetails()
    // 1) get embed url
    const res: any = await firstValueFrom(this.quickSightService.getDashboardUrl());
    const embedUrl: string = res?.embededUrl;

    console.log('Embed URL:', embedUrl);

    if (!embedUrl?.includes('/dashboards/')) {
       this.spinner.stop();
      console.error('Not a dashboard URL. getSheets will not work.');
      return;
    }

  this.embeddingContext = await createEmbeddingContext({
  onChange: async (event: any) => {
    const eventName = (event?.eventName || event?.name || event)?.toString?.() ?? '';

    if (eventName === 'CONTENT_LOADED') {
      try {
        // get sheet once
        if (!this.sheetId) {
          const sheets = await this.getSheetsWithRetry(this.dashboardExperience, 15, 1000);
          this.sheetId = sheets?.[0]?.SheetId;
          console.log('✅ sheetId:', this.sheetId);
        }

        // apply filters once, after ready
        await this.applyFilters();

      } catch (e) {
        console.error('❌ CONTENT_LOADED handler failed:', e);
      } finally {
        this.spinner.stop();
      }
    }
  }
});

    // 3) embed dashboard
    this.dashboardExperience = await this.embeddingContext.embedDashboard(
      {
        url: embedUrl,
        container: this.embeddingContainer.nativeElement,
        height: '88vh',
        width: '100%',
        locale: 'en-US'
      },
      {
        toolbarOptions: { export: true, undoRedo: true, reset: true, bookmarks: true },
        attributionOptions: { overlayContent: false }
      }
    );

await this.waitUntilDashboardReady();
await this.applyFilters();
this.spinner.stop();
    // // Optional: try once after embed (sometimes works)
    // try {
    //   const sheets = await this.getSheetsWithRetry(this.dashboardExperience, 5, 1000);
    //   console.log('✅ Sheets (early):', sheets);
    //   console.log(this.dashboardExperience);
    //    this.sheetId=sheets[0].SheetId
    //         // ✅ apply current UI filters after load
    //         await this.applyFilters();
    //   this.spinner.stop();
    // } catch {
    //   // ignore; onChange CONTENT_LOADED will handle it
    // }
  }
  
 private async getSheetsWithRetry(exp: any, attempts = 10, delayMs = 1000) {
    let lastErr: any;

    for (let i = 1; i <= attempts; i++) {
      try {
        const sheets = await exp.getSheets(); // documented method :contentReference[oaicite:2]{index=2}
        if (Array.isArray(sheets) && sheets.length) return sheets;
        lastErr = new Error('getSheets returned empty');
      } catch (e) {
        lastErr = e;
      }

      console.warn(`getSheets attempt ${i}/${attempts} failed; retrying...`, lastErr);
      await new Promise(r => setTimeout(r, delayMs));
    }

    throw lastErr;
  }
  async onProductFilter(value: any){
    this.selectedProduct = value ?? null;
    this.spinner.start()
    await this.applyFilters();
    this.spinner.stop()
  }

  

  async onDataSourceFilter(value: any){
    this.selectedDataSource = value ?? null;
     this.spinner.start()
    await this.applyFilters();
    this.spinner.stop()
  }

  async onDateRangeChange() {
  if (this.rangeStartDate && this.rangeEndDate) {
    const start = new Date(this.rangeStartDate);
    start.setHours(0,0,0,0);

    const end = new Date(this.rangeEndDate);
    end.setHours(23,59,59,999);
    this.spinner.start()
    await this.applyDateRangeFilter(start, end);
    this.spinner.stop()
  }
}

  //   onDateRangeChange() {
  //      console.log('Date range changed:', this.startDate, this.endDate);
  //      // You can emit an @Output, call API, filter data, etc.
  //      var momentObj = moment(this.startDate);
  //      console.log(momentObj.format('YYYY-MM-DD'))
  //      if(this.rangeStartDate && this.rangeEndDate){
  //        this.startDate=moment(this.rangeStartDate).format('YYYY-MM-DD')
  //        this.endDate=moment(this.rangeEndDate).format('YYYY-MM-DD')
        
  //      }
  // }



  // =========================
  // ✅ APPLY FILTERS TO DASHBOARD
  // =========================
  private async buildFilterGroup() {
    if (!this.sheetId) return null;

    const filters: any[] = [];

    // Product
    if (this.selectedProduct) {
      filters.push(
        {
          CategoryFilter: {
            Column: { ColumnName: 'DataSource', DataSetIdentifier: 'Report' },
            FilterId: 'productfilter',
            Configuration: {
              FilterListConfiguration: {
                MatchOperator: 'CONTAINS',          // valid value
                NullOption: 'NON_NULLS_ONLY',
                CategoryValues: [this.selectedProduct]
              }
            }
          }
        }
      );
    }

    // DataSource
    if (this.selectedDataSource) {
      filters.push(
        {
          CategoryFilter: {
            Column: { ColumnName: 'DataSource', DataSetIdentifier: 'Report' },
            FilterId: 'datasourcefilter',
            Configuration: {
              FilterListConfiguration: {
                MatchOperator: 'CONTAINS',          // valid value
                NullOption: 'NON_NULLS_ONLY',
                CategoryValues: [this.selectedDataSource]
              }
            }
          }
        }
      );
    }

    if(this.selectedFiltersListData.length > 0){
      for(let i = 0;i<this.selectedFiltersListData.length;i++){
        if(this.selectedFiltersListData[i].whereCondition == "=" || this.selectedFiltersListData[i].whereCondition == "LIKE" || this.selectedFiltersListData[i].whereCondition == "STARTS_WITH" || this.selectedFiltersListData[i].whereCondition == 'ENDS_WITH'){
            filters.push(
              {
                CategoryFilter: {
                  Column: { ColumnName: this.selectedFiltersListData[i].whereKey, DataSetIdentifier: 'Report' },
                  FilterId: 'productfilter',
                  Configuration: {
                    FilterListConfiguration: {
                      MatchOperator: 'CONTAINS',          // valid value
                      NullOption: 'NON_NULLS_ONLY',
                      CategoryValues: [this.selectedFiltersListData[i].whereValue]
                    }
                  }
                }
              }
            );
        }
        if(this.selectedFiltersListData[i].whereCondition == "<>" || this.selectedFiltersListData[i].whereCondition == "NOT LIKE"){
           filters.push(
              {
                CategoryFilter: {
                  Column: { ColumnName: this.selectedFiltersListData[i].whereKey, DataSetIdentifier: 'Report' },
                  FilterId: 'productfilter',
                  Configuration: {
                    FilterListConfiguration: {
                      MatchOperator: 'DOES_NOT_CONTAIN',          // valid value
                      NullOption: 'NON_NULLS_ONLY',
                      CategoryValues: [this.selectedFiltersListData[i].whereValue]
                    }
                  }
                }
              }
            );
        }
      }
    }

    // Date range
    // if (this.rangeStartDate && this.rangeEndDate) {
    //   filters.push({
    //     FilterId: 'f-date-range',
    //     Column: { DataSetIdentifier: this.DATASET_ID, ColumnName: this.COL_DATE },
    //     TimeRangeFilter: {
    //       FilterFunction: 'BETWEEN',
    //       TimeGranularity: 'DAY',
    //       RangeMinimumValue: { StaticValue: moment(this.rangeStartDate).startOf('day').toISOString() },
    //       RangeMaximumValue: { StaticValue: moment(this.rangeEndDate).endOf('day').toISOString() }
    //     }
    //   });
    // }
const visuals = await this.dashboardExperience.getSheetVisuals(this.sheetId); // get ids
const visualIds = visuals.map((v: any) => v.VisualId);

await this.dashboardExperience.setSelectedSheetId(this.sheetId);
    return {
          FilterGroupId: 'fgalertmapping',
          Filters: filters,
          ScopeConfiguration: {
            SelectedSheets: {
              SheetVisualScopingConfigurations: [{
                Scope: 'ALL_VISUALS',
                SheetId: this.sheetId
              }]
            }
          },
          CrossDataset: 'SINGLE_DATASET',
          Status: 'ENABLED'
      };
  }

  private async applyFilters() {
    try {
      if (!this.dashboardExperience || !this.sheetId) return;

      const fg = await this.buildFilterGroup();
      if (!fg) return;

      // If user selected "All" everywhere → remove filter group
      if (!fg.Filters || fg.Filters.length === 0) {
        if (this.filterGroupAdded) {
          await this.dashboardExperience.removeFilterGroups([this.FILTER_GROUP_ID]);
          this.filterGroupAdded = false;
        }
        return;
      }



      if (!this.filterGroupAdded) {
        await this.dashboardExperience.addFilterGroups([fg]);
        this.filterGroupAdded = true;
      } else {
        await this.dashboardExperience.updateFilterGroups([fg]);
      }

      console.log('✅ Filters applied:', fg);
    } catch (e) {
      console.error('❌ Failed to apply filters:', e);
    }
  }
  private async waitUntilDashboardReady(attempts = 20, delayMs = 1000) {
  let lastErr: any;

  for (let i = 1; i <= attempts; i++) {
    try {
      // Step 1: ensure sheets are available
      const sheets = await this.dashboardExperience.getSheets();
      if (Array.isArray(sheets) && sheets.length) {
        this.sheetId = sheets[0].SheetId;
      } else {
        throw new Error('Sheets empty');
      }

      // Step 2: do a "dry run" filter call to confirm dashboard accepts commands
      // We'll attempt add/remove with an empty group? QuickSight rejects empty,
      // so instead just return once getSheets works and sheetId is set.
      console.log(`✅ Dashboard ready on attempt ${i}. sheetId=${this.sheetId}`);
      return;

    } catch (e) {
      lastErr = e;
      console.warn(`waitUntilDashboardReady attempt ${i}/${attempts} failed`, e);
      await new Promise(r => setTimeout(r, delayMs));
    }
  }

  throw lastErr;
}
async applyDateRangeFilter(start: Date, end: Date) {
  if (!this.dashboardExperience || !this.sheetId) return;

  // Filter groups can only be added to the currently selected sheet
  await this.dashboardExperience.setSelectedSheetId(this.sheetId);

  const fg = {
    FilterGroupId: 'fg-date-range',
    Filters: [
      {
        TimeRangeFilter: {
          Column: {
            ColumnName: '投与開始日',     // ✅ must match EXACT field name in QS
            DataSetIdentifier: 'Report'    // ✅ your dataset identifier key
          },
          FilterId: 'dateRangeFilter',
          NullOption: 'NON_NULLS_ONLY',    // required
          TimeGranularity: 'DAY',
          IncludeMinimum: true,
          IncludeMaximum: true,
          RangeMinimumValue: {
            StaticValue: start.getTime()   // Timestamp
          },
          RangeMaximumValue: {
            StaticValue: end.getTime()     // Timestamp
          }
        }
      }
    ],
    ScopeConfiguration: {
      SelectedSheets: {
        SheetVisualScopingConfigurations: [
          {
            Scope: 'ALL_VISUALS',
            SheetId: this.sheetId
          }
        ]
      }
    },
    CrossDataset: 'SINGLE_DATASET',
    Status: 'ENABLED'
  };

  const resp = await this.dashboardExperience.addFilterGroups([fg]);
  console.log('addFilterGroups resp', resp);
}
openAdvanceFilters(){
  
  let dialogRef = this.dialog.open(SelectFiltersPopUpComponent, {
        width: "70%",
        autoFocus: false,
        maxWidth: '100vw',
        height: "70%",
        disableClose: true,
        data: {dataSetId: this.datasetData.reportcreationid, objectGroup: this.datasetData.objectGroup, columnsData: this.datasetData.columns, datasetData: this.datasetData, showVisualDropDowns: false }
      });
       dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        let selectedFiltersList = JSON.parse(result.selectedFiltersListString);
        console.log(selectedFiltersList);
        if(selectedFiltersList && selectedFiltersList.length>0){
            this.selectedFiltersListData=selectedFiltersList;
            this.applyFilters();
        }
       })
}
getDatasetDetails(){
  this.linkservice.retriveReportCreationByID(295).subscribe(response => {
      // this.spinner.start();
      console.log(response);
      // checking if response is true or not
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      } else {
        this.datasetData=response
        console.log(this.datasetData)
      }
    })
}

goBack() {
    this.back.emit();
  }

  goToAssessment(){
    console.log("**********************");
    
     this.next.emit("AlertSummary");
  }
}
